import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ReduxUserEmail: "",
  ReduxUserPassword: "",
  ReduxUserNom: "",
  ReduxUserPrenom: "",
  ReduxUserPicture: "",
  ReduxUserIdColidee: null,
  ReduxInstancesAutorisees: [],
};

export const ReduxUserSlice = createSlice({
  name: "ReduxUser",
  initialState,
  reducers: {
    chgEmail: (state, action) => {
      state.ReduxUserEmail = action.payload;
    },
    chgPassword: (state, action) => {
      state.ReduxUserPassword = action.payload;
    },
    chgNom: (state, action) => {
      state.ReduxUserNom = action.payload;
    },
    chgPrenom: (state, action) => {
      state.ReduxUserPrenom = action.payload;
    },
    chgPicture: (state, action) => {
      state.ReduxUserPicture = action.payload;
    },
    chgIdColidee: (state, action) => {
      state.ReduxUserIdColidee = parseInt(action.payload);
    },
    chgInstancesAutorisees: (state, action) => {
      state.ReduxInstancesAutorisees = action.payload;
    },
  },
});

export const {
  chgEmail,
  chgPassword,
  chgNom,
  chgPrenom,
  chgPicture,
  chgIdColidee,
  chgInstancesAutorisees,
} = ReduxUserSlice.actions;

export default ReduxUserSlice.reducer;
